<!-- <--------------new UI------------------>
<div class="panel-content">
  <div
    *ngIf="html"
    class="bookmark-description"
    [innerHtml]="html | sanitizeHtml"
  ></div>
  <div>
    <h3 class="size amass-subheadings" style="margin-top: 0px">Select Layer</h3>
    <div
      style="width: 95%"
      class="mytooltip dropdown"
      matTooltipShowDelay="1000"
      matTooltip="Layer from which to compile a selection of features."
    >
      <select
        id="select-layer"
        (change)="layerSelect($event)"
        [(ngModel)]="layerState"
      >
        <option
          value="allLayers"
          [tooltip]="tooltips['advanced-select-all-layers']"
        >
          All Layers
        </option>
        <ng-container *ngIf="layerState">
          <ng-container *ngFor="let layer of layers">
            <option *ngIf="layer.selectable" value="{{ layer.name }}">
              {{ layer.name }}
            </option>
          </ng-container>
        </ng-container>
      </select>
    </div>
    <h3 style="width: 95%" class="size amass-subheadings mytooltip">
      Selection Method
      <span
        class="tooltiptext tip-rightcenter"
        matTooltipShowDelay="1000"
        matTooltip="Layer from which to compile a selection of features."
        style="opacity: 0"
      ></span>
    </h3>
    <ul id="select-interaction" class="items-list">
      <li>
        <label
          class="mytooltip"
          [options]="myOptions2"
          [tooltip]="tooltips['advanced-select-location']"
          ><input
            name="select-tool"
            type="radio"
            value="Point"
            [checked]="sideNavService.advanceSelectState.location === 'Point'"
            (click)="selectMethod('Point')"
          />Location</label
        >
      </li>
      <li>
        <label
          class="mytooltip"
          [options]="myOptions2"
          [tooltip]="tooltips['advanced-select-box']"
          ><input
            (change)="selectMethod('Circle')"
            name="select-tool"
            type="radio"
            value="Circle"
            [checked]="sideNavService.advanceSelectState.box === 'Circle'"
          />Box</label
        >
      </li>
      <li>
        <label
          class="mytooltip"
          [options]="myOptions2"
          [tooltip]="tooltips['advanced-select-lasso']"
          ><input
            (change)="selectMethod('Polygon')"
            name="select-tool"
            type="radio"
            value="Polygon"
            [checked]="sideNavService.advanceSelectState.lasso === 'Polygon'"
          />Lasso</label
        >
      </li>
      <li *ngIf="buffer">
        <label
          class="mytooltip"
          [options]="myOptions2"
          [tooltip]="tooltips['advanced-select-buffer']"
          ><input
            (change)="selectMethod('Buffer')"
            name="select-tool"
            type="radio"
            value="Buffer"
            id="buffer"
            [checked]="sideNavService.advanceSelectState.buffer === 'Buffer'"
          />Buffer
        </label>
        <div id="Warning" *ngIf="(selectedBuffer === 'Buffer' && !showMeg) || (selectedBuffer === 'Buffer' && !mapServices.isParcelLayer)">
          <b class="now_select">NOW SELECT PARCEL</b>
        </div>
        <div
          id="buff-droplist"
          *ngIf="(selectedBuffer === 'Buffer' && Show) || (selectedBuffer === 'Buffer' && mapServices.isParcelLayer)"
        >
          <select
            name="measures"
            id="buff-value"
            (change)="selectMeasure($event)"
            [(ngModel)]="selectedSubMethod"
          >
            <option id="feet">Feet</option>
            <option id="miles">Miles</option>
            <option id="meters">Meters</option>
            <option id="kilometers">Kilometers</option></select
          ><input
            (keyup.enter)="submitBuffer()"
            type="text"
            name="select-tool"
            id="buffer-text"
            placeholder="Within..."
            [(ngModel)]="bufferValue"
            (change)="onChangeBufferValue($event)"
          /><button
            *ngIf="mapServices.hideRunButton"
            (click)="submitBuffer()"
            class="btn btn-default pull-right action button wordy mytooltip"
            id="buffer-submit"
          >
            Run
          </button>
        </div>
      </li>
    </ul>
    <div id="warn"></div>
  </div>
  <div></div>
</div>
<div class="buttonDiv">
  <a class="closer tool-toolTip">
    <img
      (click)="closeLeftPanel()"
      class="closer-img common-btns"
      src="/assets/img/tools/close-pv3.png"
      alt="closer" /><span
      class="tooltiptext tip-bottom"
      [innerHtml]="mapServices.templatetoolTips['close_left_panel']"
    ></span
  ></a>
  <a class="closer">
    <img
      (click)="clearSelection($event)"
      [tooltip]="advanceToolTip"
      [options]="myOptions4"
      class="arrow-img common-btns"
      src="/assets/img/tools/two-circling-arrows.png"
      alt="closer"
  /></a>
</div>
